import { create } from 'zustand';

interface UserNameState {
  /** userId -> name 的映射，登录后由 Layout 拉取写入 */
  nameMap: Record<string, string>;
  /** 当前登录 profile 提供的权威映射，批量请求不得覆盖 */
  nameOverrides: Record<string, string>;
  /** 是否已加载完成（避免重复请求） */
  loaded: boolean;
  setNameMap: (map: Record<string, string>) => void;
  mergeNameMap: (map: Record<string, string>) => void;
  setLoaded: (loaded: boolean) => void;
  reset: () => void;
}

export const useUserNameStore = create<UserNameState>((set) => ({
  nameMap: {},
  nameOverrides: {},
  loaded: false,
  setNameMap: (map) =>
    set((state) => ({ nameMap: { ...map, ...state.nameOverrides }, loaded: true })),
  mergeNameMap: (map) =>
    set((state) => ({
      nameMap: { ...state.nameMap, ...map },
      nameOverrides: { ...state.nameOverrides, ...map },
    })),
  setLoaded: (loaded) => set({ loaded }),
  reset: () => set({ nameMap: {}, nameOverrides: {}, loaded: false }),
}));
